module.exports = __webpack_public_path__ + "img/fdtech01.81905af6.png";